import { icons } from '../assets/icons';
import { PROJECT_CONFIG } from '../config/project-info';

export class IssueTrackerCTAComponent {
  public render(): string {
    return `
      <section class="py-16 md:py-24 border-t border-terminal-border bg-terminal-bgDark/50">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div class="max-w-4xl mx-auto rounded-3xl bg-gradient-to-br from-matrix-950/80 via-terminal-bgDark to-cyber-950/80 border border-matrix-600/40 p-6 sm:p-10 shadow-glow-lg text-left font-mono">
            
            <div class="space-y-6">
              
              <div class="space-y-2">
                <div class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-matrix-950/80 border border-matrix-800 text-xs font-semibold text-matrix-400">
                  ${icons.github('w-3.5 h-3.5')}
                  <span>Open Source & Community Driven</span>
                </div>
                <h2 class="text-2xl sm:text-3xl font-extrabold text-white tracking-tight">
                  Help Shape the Future of Mastui
                </h2>
                <p class="text-xs sm:text-sm text-terminal-muted leading-relaxed max-w-2xl">
                  Discovered a terminal glitch, have an idea for a feature, or want to contribute a keybinding patch? Mastui lives and evolves on GitHub.
                </p>
              </div>

              <!-- Action Grid -->
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-2">
                
                <!-- Bug Report -->
                <a 
                  href="${PROJECT_CONFIG.githubNewBugUrl}"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="p-4 rounded-xl bg-terminal-bgDark/80 hover:bg-terminal-card border border-terminal-border hover:border-rose-500/60 transition-all group"
                >
                  <div class="w-9 h-9 rounded-lg bg-rose-500/10 text-rose-400 flex items-center justify-center mb-2.5 group-hover:scale-110 transition-transform">
                    ${icons.bug('w-4 h-4')}
                  </div>
                  <h3 class="font-bold text-white text-sm flex items-center justify-between">
                    <span>Report a Bug</span>
                    ${icons.externalLink('w-3 h-3 text-terminal-muted group-hover:text-rose-400')}
                  </h3>
                  <p class="text-[11px] text-terminal-muted mt-1">
                    Terminal rendering or crash issue? File a detailed bug report.
                  </p>
                </a>

                <!-- Feature Request -->
                <a 
                  href="${PROJECT_CONFIG.githubNewFeatureUrl}"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="p-4 rounded-xl bg-terminal-bgDark/80 hover:bg-terminal-card border border-terminal-border hover:border-cyber-500/60 transition-all group"
                >
                  <div class="w-9 h-9 rounded-lg bg-cyber-500/10 text-cyber-400 flex items-center justify-center mb-2.5 group-hover:scale-110 transition-transform">
                    ${icons.lightbulb('w-4 h-4')}
                  </div>
                  <h3 class="font-bold text-white text-sm flex items-center justify-between">
                    <span>Feature Request</span>
                    ${icons.externalLink('w-3 h-3 text-terminal-muted group-hover:text-cyber-400')}
                  </h3>
                  <p class="text-[11px] text-terminal-muted mt-1">
                    Suggest timeline improvements or vote on roadmap ideas.
                  </p>
                </a>

                <!-- Discussions -->
                <a 
                  href="${PROJECT_CONFIG.githubDiscussionsUrl}"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="p-4 rounded-xl bg-terminal-bgDark/80 hover:bg-terminal-card border border-terminal-border hover:border-matrix-500/60 transition-all group"
                >
                  <div class="w-9 h-9 rounded-lg bg-matrix-500/10 text-matrix-400 flex items-center justify-center mb-2.5 group-hover:scale-110 transition-transform">
                    ${icons.messageSquare('w-4 h-4')}
                  </div>
                  <h3 class="font-bold text-white text-sm flex items-center justify-between">
                    <span>Discussions</span>
                    ${icons.externalLink('w-3 h-3 text-terminal-muted group-hover:text-matrix-400')}
                  </h3>
                  <p class="text-[11px] text-terminal-muted mt-1">
                    Ask setup questions, share custom keymaps, and get help.
                  </p>
                </a>

              </div>

            </div>

          </div>

        </div>
      </section>
    `;
  }
}
